import { FlyOut } from './FlyOut';

export type { TypeFlyOutProps } from './types';
export default FlyOut;
